import * as types from './mutation-types'
import { requestUtils } from '../../helpers'

const state = {
  list: []
}

const getters = {
  getCardLevels (state) {
    return state.list
  }
}

const actions = {
  loadCardLevels ({ commit, rootGetters }) {
    let headers = requestUtils.headersWithToken(rootGetters)
    return requestUtils.get('/card_levels', null, headers)
      .then((response) => {
        commit(types.SET_CARD_LEVELS, response.data)
        return response
      })
  }
}

const mutations = {
  [types.SET_CARD_LEVELS] (state, list) {
    state.list = list
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/card_level.js